import { CASES } from './constants';

export const updateRights = (payload) => {
    return { type: CASES.UPDATE_RIGHTS, payload };
};

export const updateRightsForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_RIGHTS_FORM,
        payload: { key, data },
    };
};

export const clearAssociationsDrawer = () => {
    return { type: CASES.CLEAR_ASSOCIATIONS_DRAWER, payload: {} };
};

export const clearRights = () => {
    return { type: CASES.CLEAR_RIGHTS, payload: {} };
};
